<template>
  <section
    v-if="primary"
    :class="$style.container"
    data-luko-tracking="Disclaimer"
  >
    <Wrapper :class="$style.inner">
      <RichText :text-params="primary.text" :class="$style.text" />
    </Wrapper>
  </section>
</template>

<script>
import RichText from '~/components/RichText'

export default {
  name: 'Disclaimer',

  components: {
    RichText,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
    }
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  justify-content: center;
}

.inner {
  max-width: 1135px;
  margin: 32px;
  border-radius: 8px;

  background-color: $gray-50;

  @include below(small) {
    margin: 16px;
  }

  .text {
    @include typo-sub-text;
    padding: 40px 128px;

    color: $gray-500;
    text-align: center;

    @include below(medium) {
      padding: 20px 64px;
    }
    @include below(small) {
      padding: 16px 24px;

      text-align: initial;
    }
  }
}
</style>
